export class WHSTockInDetails {
    detail : Details[];
}

export class Details {
    jobNumber : string;
    poNumber:string;
    poIssuedDate:any;
    requirementType : string
    jobType : string;
    brand : string;
    crop : string;
    language : string;
    quantity:string;
    approvedPoQuantity : string;
    remainingQuantity : string;
    estimatedDelivery : any;
    quarter:string;
    agency:string;
    warehouse:string;
    state:string;
    rmhName : string;
    vendor : string;
    brandManager:string;
    cnNumber:string;
    stockInDate:any;
    stockInQty:string;
    noOfBoxes:string;
    balQty:string;
    logistics:string;
    requestedQuantity:string;
    docketNo :string;
    invoiceNo :string;
    invoiceDate :any;
    invoiceValue:string;
    paymentDate:any;
    remarks:string;
    status :string;
    poapprovedqty:string;
    whremarks:string;
    isEdit:number;
    stockInQtyDone:any

}
export class Documents {
    file:File;
}
export class Brand{
    brandID : string;
    brandName : string;
}
export class JobType{
    jobTypeID : number;
    jobTypeName : string;
}

export class RequirementType{
    requirementTypeID : number;
    requirementTypeName : string;
}

export class Crop{
    cropID : number;
    cropName : string;
}

export class Language{
    languageID : number;
    languageName : string;
}

export class RequirementStatus{
    requirementStatusID : number;
    requirementStatusName : string;
}

export class JobNumber{
    jobNumber : string;
}
export class RMH{
    rMHCode : string;
    rMHName : string;
}
export class PO{
    pO : string;
}
export class CurrentRequirementYear{
    year: string;
    currentrequirementYear: string;
}
export class DropDownResponse {
    brands: Array<Brand> = new Array<Brand>()
    crops: Array<Crop> = new Array<Crop>()
    jobNumbers: Array<JobNumber> = new Array<JobNumber>()
    jobTypes: Array<JobType> = new Array<JobType>()
    languages: Array<Language> = new Array<Language>()
    requirementTypes: Array<RequirementType> = new Array<RequirementType>()
    rmhs: Array<RMH> = new Array<RMH>()
    status: Array<RequirementStatus> = new Array<RequirementStatus>()
    po: Array<PO> = new Array<PO>()
    currentRequirementYear: Array<CurrentRequirementYear> = new Array<CurrentRequirementYear>()
}